export function calcPercentage(obtained = 0, total = 0) {
  if (total === 0) {
    return 0;
  }
  return Math.round((obtained / total) * 100);
}
